// extracted by mini-css-extract-plugin
export default {"ScrollToTopButton":"ScrollToTopButton_ScrollToTopButton__qRPLH","fadeIn":"ScrollToTopButton_fadeIn__vIDAj","ScrollToTopButtonHover":"ScrollToTopButton_ScrollToTopButtonHover__RTm0-"};